import React, { useState } from 'react';
import Add_blog from './Add_blog';
import Add_pro from './Add_pro';
import Manage_Projects from './Manage_Projects';
import Change_pass from './Change_pass';
import Manage_Blogs from './Manage_Blog';
import Logout from './Logout';
import './Admin.css';

const Admin = () => {
    const [topBar, setTopBar] = useState(0);
    const topNavBar = (
        <div className="topnav">
            <span onClick={() => setTopBar(0)} className="active">Add Projects</span>
            <span onClick={() => setTopBar(1)}>Manage Projects</span>
            <span onClick={() => setTopBar(2)}>Add Blogs</span>
            <span onClick={() => setTopBar(3)}>Manage Blogs</span>
            <span onClick={() => setTopBar(4)}>Change password</span>
            <span onClick={() => setTopBar(5)}>Logout</span>
        </div>

    )

    const topNavBarManage = (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>Add Projects</span>
            <span onClick={() => setTopBar(1)} className="active">Manage Projects</span>
            <span onClick={() => setTopBar(2)}>Add Blogs</span>
            <span onClick={() => setTopBar(3)}>Manage Blogs</span>
            <span onClick={() => setTopBar(4)}>Change password</span>
            <span onClick={() => setTopBar(5)}>Logout</span>
        </div>

    )

    const topNavBarAddBlogs = (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>Add Projects</span>
            <span onClick={() => setTopBar(1)}>Manage Projects</span>
            <span onClick={() => setTopBar(2)} className="active">Add Blogs</span>
            <span onClick={() => setTopBar(3)}>Manage Blogs</span>
            <span onClick={() => setTopBar(4)}>Change password</span>
            <span onClick={() => setTopBar(5)}>Logout</span>
        </div>

    )

    const topNavBarManageBlogs = (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>Add Projects</span>
            <span onClick={() => setTopBar(1)}>Manage Projects</span>
            <span onClick={() => setTopBar(2)}>Add Blogs</span>
            <span onClick={() => setTopBar(3)} className="active">Manage Blogs</span>
            <span onClick={() => setTopBar(4)}>Change password</span>
            <span onClick={() => setTopBar(5)}>Logout</span>
        </div>

    )

    const topNavBarPassword = (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>Add Projects</span>
            <span onClick={() => setTopBar(1)}>Manage Projects</span>
            <span onClick={() => setTopBar(2)}>Add Blogs</span>
            <span onClick={() => setTopBar(3)}>Manage Blogs</span>
            <span onClick={() => setTopBar(4)} className="active">Change password</span>
            <span onClick={() => setTopBar(5)}>Logout</span>
        </div>

    )

    const topNavBarLogout = (
        <div className="topnav">
            <span onClick={() => setTopBar(0)}>Add Projects</span>
            <span onClick={() => setTopBar(1)}>Manage Projects</span>
            <span onClick={() => setTopBar(2)}>Add Blogs</span>
            <span onClick={() => setTopBar(3)}>Manage Blogs</span>
            <span onClick={() => setTopBar(4)}>Change password</span>
            <span onClick={() => setTopBar(5)} className="active">Logout</span>
        </div>

    )



    return (
        <div>
            {
                topBar === 0 ? topNavBar :
                topBar === 1 ? topNavBarManage :
                topBar === 2 ? topNavBarAddBlogs :
                topBar === 3 ? topNavBarManageBlogs :
                topBar === 4 ? topNavBarPassword :
                topNavBarLogout
            }
            <section className="d-flex justify-content-center align-items-center admin-parent">
                {
                    topBar === 0 ? <Add_pro /> :
                    topBar === 1 ? <Manage_Projects /> :
                    topBar === 2 ? <Add_blog /> :
                    topBar === 3 ? <Manage_Blogs /> :
                    topBar === 4 ? <Change_pass /> :
                    <Logout />
                }
            </section>
        </div>
    );
};

export default Admin;